<template>
  <el-card>
    <ht-action-panel :on-search="onSearch" :on-clear="onClearSearch">
      <template slot="left">
        <el-input v-model="listQuery.name" placeholder="工程名称" />
        <el-input v-model="listQuery.location" placeholder="工程地址" />
        <el-date-picker
          v-model="createdAt"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          placement="bottom-start"
          start-placeholder="工程开始日期"
          end-placeholder="工程结束日期"
        />
        <el-select v-model="listQuery.isFinished" placeholder="工程状态">
          <el-option v-for="item in ProjectStatusEnum" :key="item.name" :label="item.value" :value="item.name" />
        </el-select>
      </template>
    </ht-action-panel>

    <ht-table ref="list" v-loading="isLoading" :data="list" style="cursor: pointer" @row-click="handleRowClick">
      <ht-table-column label="序号" type="index" fixed="left" />
      <ht-table-column
        v-for="item in ProjectListTitle"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
        :min-width="item.width || 100"
        :fixed="isMobile ? false : item.fixed"
      >
        <template v-slot="{row}">
          <span v-if="item.label === '工程地址'">
            {{ row[item.prop] || '-' }}
            <!--            {{ row[item.prop] ? row[item.prop] || '-' :getAddress('',row.province && row.province.name, row.city && row.city.name, row.district && row.district.name, row.address) || '-' }}-->
          </span>
          <span v-else-if="item.label === '工程起止日期'">
            {{ row.projectStartAt ? `${row.projectStartAt}至${row.projectEndAt}` : '-' }}
          </span>
          <template v-else-if="item.label === '工程资料'">
            <el-link
              :type="row.attachmentData && row.attachmentData.length > 0 ? 'primary': 'info'"
              :disabled="row.attachmentData && row.attachmentData.length === 0"
              @click="openDocumentDialog(row)"
            >{{ row.attachmentData && row.attachmentData.length || 0 }}</el-link>
          </template>
          <span v-else-if="item.label === '绑定客户账号'">
            {{ row.customer ? row.customer.fullName: '-' }}
          </span>
          <template v-else-if="item.label === '关联工单'">
            <el-link
              :type="row.workOrderCount > 0 ? 'primary': 'info'"
              :disabled="row.workOrderCount === 0"
              @click="openWorkOrderDialog(row)"
            >{{ row.workOrderCount || 0 }}</el-link>
          </template>
          <template v-else-if="item.label === '工程进度'">
            <el-progress v-if="row[item.prop] || row[item.prop] === 0" :percentage="row[item.prop]" :show-text="!row.isFinished" style="width: 95%" :color="row.isFinished ? '#e6ebf5' : '#2e5aff'" />
            <template v-else>-</template>
          </template>
          <el-tag v-else-if="item.label === '工程状态'" :type="getProjectStatus(row[item.prop]).style">{{ getProjectStatus(row[item.prop]).value || '-' }}</el-tag>
          <span v-else-if="item.label === '现存设备数'">{{ row[item.prop] || 0 }}</span>
          <span v-else>{{ row[item.prop] || '-' }}</span>
        </template>
      </ht-table-column>
      <ht-table-column-operation v-if="isMobile" :width="110">
        <template v-slot="{row}">
          <dw-table-dropdown-buttons :buttons="row.buttons" :row="row" @handle-button-click="handleButtonClick(row,arguments)" />
        </template>
      </ht-table-column-operation>
      <ht-table-column-operation v-else :width="160">
        <template v-slot="{row}">
          <ht-button :disabled="row.isFinished" type="text" icon="el-icon-setting" @click="openLeaseEquipmentMgrDialog(row)">租用设备</ht-button>
          <ht-button icon="el-icon-view" type="text" @click="onView(row)">详情</ht-button>
        </template>
      </ht-table-column-operation>
    </ht-table>
    <ht-pagination style="float: right;margin-bottom: 10px" :total="page.total" :page.sync="listQuery.page" :limit.sync="listQuery.perPage" @pagination="getList" />
    <ht-dialog ref="documentDialog" title="工程资料" :width="isMobile? '100%' : '800px'" @close="closeDocumentDialog">
      <div slot="content">
        <document-list v-if="showDocumentList" ref="documentList" :document-list="documentList" :show-operation="false" />
      </div>
    </ht-dialog>
    <ht-dialog ref="workOrderDialog" title="工程工单" :width="isMobile? '100%' : '1000px'" @close="closeWorkOrderDialog">
      <div slot="content">
        <el-tabs v-model="workOrderActiveName" @tab-click="getWorkOrderList">
          <el-tab-pane v-for="(item, index) in getTaskTempTypeEnum()" :key="index" :label="item.value" :name="item.name" />
        </el-tabs>
        <work-order-list
          v-if="showWorkOrderList"
          ref="workOrderList"
          :is-loading="isWorkOrderLoading"
          :table-title="workOrderTableTitle"
          :list="workOrderList"
          :page="workOrderPage"
          :list-query="workOrderListQuery"
        />
      </div>
    </ht-dialog>

    <ht-dialog ref="leaseEquipmentMgrDialog" title="租用设备管理" :width="isMobile? '100%' : '800px'" @close="closeLeaseEquipmentMgrDialog">
      <div slot="content">
        <lease-equipment-mgr
          v-if="showLeaseEquipmentMgr"
          ref="leaseEquipmentMgr"
          is-view
          :project-id="projectId"
          :project-data="projectData"
        />
      </div>
    </ht-dialog>
  </el-card>
</template>

<script>
import HtListContainer from '@/components/HtListContainer'
import DocumentList from '@/views/constructionProjectMgr/projectMgr/components/documentList'
import WorkOrderList from '@/views/constructionProjectMgr/projectMgr/components/workOrderList'
import LeaseEquipmentMgr from '@/views/constructionProjectMgr/projectMgr/components/leaseEquipmentMgr'
import { ProjectListTitle } from '@/views/constructionProjectMgr/projectMgr/tableTitle'
import {
  ProjectLeaseStatusEnum,
  ProjectLeaseStatusStyleEnum,
  ProjectStatusEnum
} from '@/views/constructionProjectMgr/projectMgr/enum'
import { PatrolWorkOrderListTitle, RepairWorkOrderListTitle } from '@/views/taskMgr/tableTitle'
import { getAddress, getProjectStatus } from '@/utils/get-display'
import { getProject, getProjects, getProjectTaskWorkOrders } from '@/api/constructionProjectMgr/projectMgr'
import { mapGetters } from 'vuex'
import { getTaskTempTypeEnum } from '@/views/taskMgr/commonJs'

export default {
  name: 'List',
  components: { DocumentList, LeaseEquipmentMgr, WorkOrderList },
  extends: HtListContainer,
  data() {
    return {
      ProjectListTitle,
      ProjectStatusEnum,
      ProjectLeaseStatusEnum, ProjectLeaseStatusStyleEnum,
      PatrolWorkOrderListTitle, RepairWorkOrderListTitle,
      showDocumentList: false,
      documentList: [],
      showLeaseEquipmentMgr: false,
      showWorkOrderList: false,
      projectId: undefined,
      projectData: undefined,
      workOrderActiveName: 'PATROL',
      isWorkOrderLoading: false,
      workOrderTableTitle: PatrolWorkOrderListTitle,
      workOrderList: [],
      workOrderPage: { total: 0 },
      workOrderListQuery: { page: 1, perPage: 20 },
      createdAt: []
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'isMobile'])
  },
  created() {
    this.getList()
  },
  methods: {
    getAddress, getTaskTempTypeEnum, getProjectStatus,
    onClearSearch() {
      this.createdAt = []
      this.onClear()
    },
    async getList() {
      this.beforeGetList()
      this.listQuery.createdStartAt = this.createdAt[0]
      this.listQuery.createdEndAt = this.createdAt[1]
      this.listQuery.customerId = this.userInfo.id
      await getProjects(this.listQuery).then((resp) => {
        resp.items.forEach(item => {
          item.workOrderCount = item.workOrderCount || 0
          item.progressRatio = parseFloat((item.progressRatio * 100).toFixed(2))
          item.buttons = [
            { name: '租用设备', icon: 'el-icon-setting', isPopoverButton: false, disabled: item.isFinished },
            { name: '详情', icon: 'el-icon-view', isPopoverButton: false }
          ]
        })
        this.afterGetList(resp)
      }).catch(() => {
        this.isLoading = false
      })
    },
    handleRowClick(row, column) {
      if (column.label !== '工程资料' && column.label !== '关联工单' && column.label !== '操作') {
        this.onView(row)
      } else if (column.label === '工程资料') {
        this.openDocumentDialog(row)
      } else if (column.label === '关联工单') {
        this.openWorkOrderDialog(row)
      }
    },
    onView(row) {
      this.$router.push({
        name: 'projectConsultView',
        params: { projectId: row.id, isEdit: 0 }
      })
    },
    openDocumentDialog(row) {
      this.documentList = row.attachmentData
      this.showDocumentList = true
      this.$refs.documentDialog.dialogVisible = true
    },
    closeDocumentDialog() {
      this.documentList = []
      this.showDocumentList = false
      this.$refs.documentDialog.dialogVisible = false
    },
    openWorkOrderDialog(row) {
      this.projectId = row.id
      this.showWorkOrderList = true
      this.$refs.workOrderDialog.dialogVisible = true
      this.$nextTick(() => {
        this.getWorkOrderList()
      })
    },
    closeWorkOrderDialog() {
      this.showWorkOrderList = false
      this.$refs.workOrderDialog.dialogVisible = false
      this.workOrderActiveName = 'PATROL'
      this.workOrderList = []
    },
    getWorkOrderList() {
      this.workOrderListQuery.type = this.workOrderActiveName
      this.workOrderTableTitle = this.workOrderActiveName === 'PATROL' ? PatrolWorkOrderListTitle : RepairWorkOrderListTitle
      this.isWorkOrderLoading = true
      getProjectTaskWorkOrders(this.projectId, this.workOrderListQuery).then(resp => {
        this.isWorkOrderLoading = false
        this.workOrderList = resp.items
        this.workOrderPage = resp.page
      }).catch(() => {
        this.isWorkOrderLoading = false
      })
    },
    handleButtonClick(row, $argument) {
      switch ($argument[0]) {
        case '租用设备':
          this.openLeaseEquipmentMgrDialog(row)
          break
        case '详情':
          this.onView(row)
          break
      }
    },
    openLeaseEquipmentMgrDialog(row) {
      getProject(row.id).then(resp => {
        this.projectId = row.id
        this.projectData = resp
        this.showLeaseEquipmentMgr = true
        this.$refs.leaseEquipmentMgrDialog.dialogVisible = true
        this.$nextTick(() => {
          this.$refs.leaseEquipmentMgr.getProjectInfo(this.projectData)
        })
      })
    },
    closeLeaseEquipmentMgrDialog() {
      this.showLeaseEquipmentMgr = false
      this.$refs.leaseEquipmentMgrDialog.dialogVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-table__body tr.hover-row>td{
  background-color: #eaecfc !important;
}

.img-container{
  display: flex;
  align-items: center;
  justify-content: center;
  .img{
    width: 20px;
  }
}

.el-progress.el-progress--line{
  text-align: left;
}
</style>
